import { useState, useEffect } from "react";

const Iphone = ({
  previewItems,
  size = "default",
}: {
  previewItems: string[];
  size?: "small" | "default";
}) => {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);

  useEffect(() => {
    if (previewItems.length === 0) return;

    const interval = setInterval(() => {
      setCurrentItemIndex((prevIndex) =>
        prevIndex === previewItems.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000); // Switch every 1 second

    return () => clearInterval(interval); // Cleanup on unmount
  }, [previewItems]);

  return (
    <div
      className={"flex-cen-stack"}
      style={{
        marginRight: 36,
        height: size === "small" ? "250px" : "100%",
        overflow: "hidden",
      }}
    >
      <div className="marvel-device iphone8 silver" style={{ zoom: 0.5 }}>
        <div className="top-bar"></div>
        <div className="sleep"></div>
        <div className="volume"></div>
        <div className="camera"></div>
        <div className="sensor"></div>
        <div className="speaker"></div>
        <div
          className="screen p-4"
          style={{
            backgroundImage: `url('/phone-bg.jpg')`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        >
          <div
            className={
              "screen-container mt-20 p-4 rounded-2xl text-2xl text-white"
            }
            style={{ backgroundColor: "rgba(31, 41, 55, 0.5)" }}
          >
            <div>{previewItems[currentItemIndex]}</div>
          </div>
        </div>
        <div className="home"></div>
        <div className="bottom-bar"></div>
      </div>
    </div>
  );
};

export default Iphone;
